<template>
  <div>
    <v-divider v-if="index > 0"/>
    <v-list-item
        :to="{ name: 'car-view', params: { id: id }}"
        class="px-0"
    >
      <v-container class="pa-0 pa-md-2">
        <v-row no-gutters="true">
          <v-col v-if="$vuetify.display.smAndDown" cols="12">
            <v-row no-gutters="true">
              <p class="text-subtitle-1">{{ title }}</p>
            </v-row>
            <v-row no-gutters="true">
              <v-col>
                <p class="text-h6 font-weight-bold text-no-wrap text-center">{{ firstPrice }}</p>
              </v-col>
              <v-col>
              <p class="text-h6 font-weight-bold text-no-wrap text-center">{{ secondPrice }}</p>
              </v-col>
                <v-col>
              <p class="text-h6 font-weight-bold text-no-wrap text-center">{{ thirdPrice }}</p>
                </v-col>
            </v-row>
          </v-col>
          <v-col
              cols="12"
              md="3"
          >
            <v-img
                :src="mainPhoto"
                class="rounded"
            />
          </v-col>
          <v-col
              cols="12"
              md="7"
              class="px-0 px-md-2 pt-2 pt-md-0"
          >
            <v-row
                v-if="$vuetify.display.mdAndUp"
                :no-gutters="true"
            >
              <v-col cols="12" md="8" align-self="center">
                <p class="text-h6 font-weight-regular">{{ title }}</p>
              </v-col>
            </v-row>
            <v-row no-gutters="true">
              <v-col>
                <p class="font-weight-regular text-subtitle-1">{{ subtitle }}</p>
              </v-col>
            </v-row>
            <v-row no-gutters="true">
              <v-col>
                <p class="font-weight-regular text-body-1">{{ description }}</p>
              </v-col>
            </v-row>
          </v-col>
          <v-col
              v-if="$vuetify.display.mdAndUp"
              :md="2"
          >
            <v-row
                no-gutters="true"
                justify="end"
                align="center"
            >
              <p class="font-weight-light text-no-wrap text-center">exw. price</p>
              <v-tooltip text="The price paid for the product ex-works (i.e. when it leaves the factory)">
                <template v-slot:activator="{ props }">
                  <v-btn
                      v-bind="props"
                      icon="mdi-help"
                      size="x-small"
                      variant="plain"
                      class="pb-1"
                  />
                </template>
              </v-tooltip>
            </v-row>
            <v-row
                no-gutters="true"
                justify="end"
            >
              <p class="text-h4 font-weight-light text-no-wrap">{{ firstPrice }}</p>
            </v-row>
            <v-row
                no-gutters="true"
                justify="end"
            >
              <p class="text-h4 font-weight-light text-no-wrap">{{ secondPrice }}</p>
            </v-row>
            <v-row
                no-gutters="true"
                justify="end"
            >
              <p class="text-h4 font-weight-light text-no-wrap">{{ thirdPrice }}</p>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-list-item>
  </div>
</template>

<script>

export default {
  name: "CarListItem",
  props: {
    index: Number,
    id: String,
    title: String,
    firstPrice: String,
    secondPrice: String,
    thirdPrice: String,
    subtitle: String,
    description: String,
    mainPhoto: String
  }
}
</script>

<style scoped>

</style>